import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'

import { RootState } from '@store/Store'
import { setStoreLanguage } from '@store/Slices/LanguageState'

import { Mobile, PC } from '@hooks/useMediaQueryHook'

import { css } from '@emotion/react'

import { ReactComponent as DownArrow } from '@assets/svg/DropdownArrow.svg'
import { ReactComponent as LanguageIcon } from '@assets/svg/LanguageIcon.svg'
import { ReactComponent as Cirlce } from '@assets/svg/PcLanguageCircle.svg'
import { awsImgSrc } from '@utils/function/globalFunction'
import { langs } from '@utils/locales/globalLang'
import { toggleRemoconModal } from '@store/Slices/RemoconModal'

// 메뉴 화살표 움직임
const svgAnimation = (isMenu: boolean, isMobile: boolean) => css`
  svg {
    width: ${isMobile ? '24px' : '14px'};
    height: ${isMobile ? '24px' : '14px'};
    transform: ${isMenu ? 'rotate(-180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease-in-out;
    path {
      stroke: ${isMenu ? '#F9F9FB' : '#787878'};
      transition: stroke 0.3s ease-in-out;
    }
  }
`

// 모바일 pathname 스타일
const pathNameStyle = css`
  .path_on {
    padding-bottom: 2px;
    border-bottom: 1px solid white;
  }
  .path_off {
    color: #787878;
  }
  @media screen and (min-width: 1100px) {
    .path_on {
      padding-bottom: 0px;
      border-bottom: 0px solid transparent;
    }
    .path_off {
      color: #787878;
    }
  }
`

// 헤더 전체스타일
const headerStyle = (
  isMobile: boolean,
  mobileBurger: boolean,
  over332: boolean,
  storeLanguage: 'ko' | 'en',
  menuArray: number[],
) => css`
  position: fixed;
  width: 100%;
  background-color: ${over332 || mobileBurger ? 'black' : 'transparent'};
  padding-top: ${over332 && !mobileBurger ? '0px' : '41px'};
  z-index: 3;
  transition: all 0.7s ease-in-out;

  .header_container {
    padding: ${mobileBurger ? '15px 20px 0px' : '15px 20px'};
    display: flex;
    position: relative;
    .header_logo {
      height: ${isMobile ? '26px' : '37px'};
      position: ${isMobile ? 'relative' : 'absolute'};
      z-index: 2;
      left: ${isMobile ? '0px' : '78px'};
      transition: left 0.3s ease-out;
      img {
        display: ${mobileBurger ? 'none' : 'block'};
        width: 64px;
        height: 100%;
      }
    }
    .header_burger {
      display: ${isMobile ? 'block' : 'none'};
      position: absolute;
      right: 20px;
      top: 19px;
      z-index: 2;
      .burger {
        position: relative;
        width: 18px;
        height: 18px;
        background: transparent;
        cursor: pointer;
        display: block;
      }

      .burger input {
        display: none;
      }

      .burger span {
        display: block;
        position: absolute;
        height: 2px;
        width: 100%;
        background: white;
        border-radius: 9px;
        opacity: 1;
        left: 0;
        transform: rotate(0deg);
        transition: 0.25s ease-in-out;
      }

      .burger span:nth-of-type(1) {
        top: 15%;
        transform-origin: left center;
      }

      .burger span:nth-of-type(2) {
        top: 50%;
        transform: translateY(-50%);
        transform-origin: left center;
      }

      .burger span:nth-of-type(3) {
        top: 85%;
        transform-origin: left center;
        transform: translateY(-100%);
      }

      .burger .burgerOn ~ span:nth-of-type(1) {
        transform: rotate(45deg);
        top: 2px;
        left: 3px;
      }

      .burger .burgerOn ~ span:nth-of-type(2) {
        width: 0%;
        opacity: 0;
      }

      .burger .burgerOn ~ span:nth-of-type(3) {
        transform: rotate(-45deg);
        top: 15px;
        left: 3px;
      }
    }
    .header_menu {
      display: flex;
      flex-direction: column;
      position: fixed;
      width: 100%;
      height: ${mobileBurger ? '-webkit-fill-available' : '0px'};
      padding: 0px 24px;
      margin: 81px 0 0;
      background-color: ${mobileBurger ? 'black' : 'transparent'};
      transform: ${mobileBurger ? 'translateY(0px)' : 'translateY(-30%)'};
      transition:
        transform 0.7s ease-in-out,
        background-color 0.7s ease-in-out;
      overflow: hidden auto;
      top: 0px;
      left: 0px;
      z-index: 1;
      overscroll-behavior: contain;
      > .menu_div:nth-of-type(n + 2) {
        margin-top: 40px;
      }
      .menu_div {
        font-size: 20px;
        font-weight: 700;
        line-height: 160%;
        height: 37px;
        opacity: ${mobileBurger ? '1' : '0'};
        transition: ${mobileBurger ? 'opacity 1s ease-in-out 0.3s' : 'auto'};
        .menu_title {
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 20px;
          a {
            font-size: 20px;
            font-weight: 700;
            line-height: 160%;
          }
        }
        a {
          font-size: 20px;
          font-weight: 700;
          line-height: 160%;
        }
      }

      .menu_ul {
        position: static;
        overflow: hidden;
        background-color: transparent;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex: 0 0 auto;
        .menu_li {
          padding: 0px 48px;
          margin-top: 30px;
          a {
            cursor: pointer;
            display: inline-block;
            position: relative;
            height: 26px;
            font-weight: 600;
            line-height: 160%;
          }
        }
      }
      .menu_ul_on {
        height: auto;
        opacity: 1;
        transition:
          opacity 0.5s ease-in-out,
          height 0.5s ease-in-out;
      }
      .menu_ul_off {
        height: 0;
        opacity: 0;
      }
      .mobile_language {
        margin: 56px 0 56px;
        display: flex;
        align-items: center;
        gap: 8px;
        opacity: ${mobileBurger ? 1 : 0};
        transition: ${mobileBurger ? 'opacity 1s ease-in-out 0.4s' : 'auto'};
        .language_text_ko {
          font-weight: 500;
          font-size: 14px;
          color: ${storeLanguage === 'ko' ? '#F9F9FB' : '#787878'};
        }
        .language_text_en {
          font-weight: 500;
          font-size: 14px;
          color: ${storeLanguage === 'en' ? '#F9F9FB' : '#787878'};
        }
      }
      .language_line {
        width: 1px;
        height: 14px;
        background: var(--Text_Dark-Body, #a8a8a8);
      }
    }
  }

  // 웹 한국어 일때 반응형 로고 움직임
  @media screen and (min-width: 1100px) and (max-width: 1260px) {
    .header_container {
      .header_logo {
        left: 5px;
      }
    }
  }
  // 웹 영어 일때 반응형 로고움직임
  @media screen and (min-width: 1100px) and (max-width: 1460px) {
    .header_container {
      .header_logo {
        left: 5px;
      }
    }
  }

  @media screen and (min-width: 1100px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 0px;
    min-width: ${storeLanguage === 'ko' ? '1200px' : '1400px'};
    .header_container {
      padding: 0px;
      height: 37px;
      width: 100%;
      .header_logo {
        img {
          width: 90.5px;
        }
      }
      .header_menu {
        display: flex;
        flex-direction: row;
        position: relative;
        justify-content: center;
        gap: 72px;
        width: 100%;
        height: ${menuArray.length ? '148px' : '100%'};
        padding: 0px;
        margin: 0px;
        background-color: transparent;
        transform: translateY(0px);
        transition: none;
        overflow: hidden;
        z-index: 1;
        overscroll-behavior: unset;
        > .menu_div:nth-of-type(n + 2) {
          margin-top: 0px;
        }
        .menu_div {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 16px;
          line-height: 160%;
          width: auto;
          gap: 4px;
          font-weight: 400;
          opacity: 1;
          transition: ${mobileBurger
            ? 'opacity 0.4s ease-in-out 0.7s'
            : 'auto'};
          .menu_title {
            gap: 4px;
            font-size: 16px;
          }
          a {
            font-size: 16px;
            font-weight: 400;
            line-height: 160%;
          }
        }
        .title_on {
          a {
            font-weight: 800;
          }
          .menu_title {
            font-weight: 800;
          }
        }
        .title_off {
          a {
            font-weight: 400;
          }
          .menu_title {
            font-weight: 400;
            /* color: #787878; */
          }
        }

        .menu_ul {
          position: absolute;
          overflow: auto;
          background: linear-gradient(
            0deg,
            rgba(29, 29, 29, 1) 0%,
            rgba(73, 73, 73, 1) 100%
          );
          width: 120px;
          height: 100px;
          display: flex;
          flex-direction: column;
          flex: auto;
          padding: 0px;
          margin-top: 0px;
          top: 45px;
          z-index: 3;
          border-radius: 8px;
          padding: 0px 14px;
          .menu_li {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0px;
            margin-top: 0px;
            height: 100%;
            a {
              cursor: pointer;
              display: inline-block;
              position: relative;
              height: 26px;
              line-height: 160%;
            }
            .path_on {
              text-align: center;
              width: 100%;
              font-weight: 600;
            }
            .path_off {
              text-align: center;
              width: 100%;
              font-weight: 400;
            }
          }
        }
        .menu_ul_on {
          overflow: hidden;
          height: 100px;
          opacity: 1;
          transition:
            opacity 0.5s ease-in-out,
            height 0.5s ease-in-out;
        }
        .menu_ul_off {
          overflow: hidden;
          height: 0;
          opacity: 0;
          transition:
            opacity 0.5s ease-in-out,
            height 0.5s ease-in-out;
        }
      }

      .pc_language {
        padding-right: 78px;
        right: 0px;
        position: absolute;
        height: 37px;
        display: flex;
        align-items: center;
        gap: 4px;

        .language_title {
          cursor: pointer;
          display: flex;
          gap: 4px;
          position: relative;
          svg {
            width: 20px;
            height: 20px;
          }
        }
        .web_language_ul {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: absolute;
          width: 110px;
          top: 45px;
          left: 0px;
          padding: 0px 14px;
          overflow: hidden;
          border-radius: 8px;
          background: linear-gradient(
            0deg,
            rgba(29, 29, 29, 1) 0%,
            rgba(73, 73, 73, 0.8) 100%
          );
          .web_language_li {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0;
            gap: 8px;
          }
          .language_line {
            width: 100%;
            height: 1px;
            background: rgb(85, 85, 85);
          }
          .web_language_li_on {
            font-weight: 800;
          }
          .web_language_li_off {
            color: #787878;
            font-weight: 400;
          }
        }
        .language_ul_on {
          opacity: 1;
          //번역완료후
          /* height: 100px; */
          height: 49.75px;
          transition:
            opacity 0.5s ease-in-out,
            height 0.5s ease-in-out;
        }
        .language_ul_off {
          opacity: 0;
          height: 0px;
          transition:
            opacity 0.5s ease-in-out,
            height 0.5s ease-in-out;
        }
      }
    }
  }
`

const ListComponent = ({
  menuArray,
  menuIdx,
  mainMenuClose,
  textArray,
}: {
  menuArray: number[]
  menuIdx: number
  mainMenuClose: (text: string) => void
  textArray: string[]
}) => {
  const storeLanguage = useSelector((state: RootState) => state.language)
  const { pathname } = useLocation()
  const [first, second] = textArray
  const isMobile = useMediaQuery({ query: '(max-width:1099px)' })

  return (
    <ul
      className={`menu_ul ${menuArray.includes(menuIdx) ? 'menu_ul_on' : 'menu_ul_off'}`}
    >
      <li className="menu_li" css={pathNameStyle}>
        <Link
          to={`https://corp.indj.ai/${storeLanguage === 'ko' ? `${first}` : `${first}/en`}`}
          className={pathname.includes(first) ? 'path_on' : 'path_off'}
          onClick={() => mainMenuClose('')}
        >
          {langs[first][storeLanguage]}
        </Link>
      </li>
      {isMobile ? (
        ''
      ) : (
        <div
          css={{
            height: '1px',
            width: '100%',
            background: 'rgb(85, 85, 85)',
            display: 'flex',
            alignSelf: 'center',
            pointerEvents: 'none',
          }}
        ></div>
      )}
      <li className="menu_li" css={pathNameStyle}>
        <Link
          to={`https://corp.indj.ai/${storeLanguage === 'ko' ? `${second}` : `${second}/en`}`}
          className={pathname.includes(second) ? 'path_on' : 'path_off'}
          onClick={() => mainMenuClose('')}
        >
          {langs[second][storeLanguage]}
        </Link>
      </li>
    </ul>
  )
}

const Header = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { pathname } = useLocation()
  const storeLanguage = useSelector((state: RootState) => state.language)
  const isMobile = useMediaQuery({ query: '(max-width:1099px)' })

  // 상태
  const [mobileMenuState, setMobileMenuState] = useState(false)
  const [menuArray, setMenuArray] = useState<number[]>([])
  const [over332, setOver332] = useState(false)

  // 한국어 영어 버튼 함수
  const langOnClick = (props: 'ko' | 'en') => {
    return dispatch(setStoreLanguage(props))
  }
  // 헤더 백그라운드를 위한 함수
  const handleScroll = () => {
    return window.scrollY >= 332 ? setOver332(true) : setOver332(false)
  }
  // pc 헤더 해당URL 하이라이트
  const headerHilightClass = (text: string = '', urlArray: string[] = []) => {
    let isClassName = ''
    // 서브메뉴 x
    if (text) {
      const isUrl = pathname === `${text}` || pathname === `${text}/en`
      isClassName = isUrl ? 'title_on' : 'title_off'
    }
    // 서브메뉴 o
    else if (!text) {
      const isUrl =
        pathname.includes(urlArray[0]) || pathname.includes(urlArray[1])
      isClassName = isUrl ? 'title_on' : 'title_off'
    }
    return isClassName
  }
  const mainMenuClose = (text: string) => {
    if (text === 'contect') {
      return window.open('http://localhost:3000/?modal=true', '_self')
    }

    setMenuArray([])
    return setMobileMenuState(false)
  }
  // 메인메뉴 클릭시 서브메뉴바 열리는 함수
  const isOpenSubMenu = (menuIdx: number) => {
    // mobile 일 때
    if (isMobile) {
      setMenuArray((prevArray) => {
        if (prevArray.includes(menuIdx)) {
          return prevArray.filter((item) => item !== menuIdx)
        }
        return [...prevArray, menuIdx]
      })
    }

    // pc 일때
    else {
      setMenuArray((prevArray) => {
        if (prevArray.includes(menuIdx)) {
          return prevArray.filter((item) => item !== menuIdx)
        }
        return [menuIdx]
      })
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header
      css={headerStyle(
        isMobile,
        mobileMenuState,
        over332,
        storeLanguage,
        menuArray,
      )}
    >
      <div className="header_container">
        <div className="header_logo">
          <Link to="https://indj.ai/">
            <img
              src={awsImgSrc('global', isMobile, 'logo')}
              alt="인디제이로고"
            />
          </Link>
        </div>

        <div className="header_burger">
          <label className="burger" htmlFor="burger">
            <input
              type="checkbox"
              id="burger"
              className={`${mobileMenuState ? 'burgerOn' : 'burgerOff'}`}
              onClick={() => setMobileMenuState((el) => !el)}
            />
            <span></span>
            <span></span>
            <span></span>
          </label>
        </div>
        <div className="header_menu">
          {/* 회사소개 */}
          <div
            className={`menu_div ${isMobile ? '' : headerHilightClass(`${storeLanguage === 'ko' ? '/' : '/en'}`)}`}
          >
            <Link
              to={`${storeLanguage === 'ko' ? 'https://corp.indj.ai/' : 'https://corp.indj.ai/en'}`}
              onClick={() => mainMenuClose('')}
            >
              {langs.company[storeLanguage]}
            </Link>
          </div>
          {/* 기술제휴 */}
          <div
            className={`menu_div ${isMobile ? '' : headerHilightClass('', ['tech', 'voucher'])}`}
          >
            <div
              className={`menu_title `}
              css={svgAnimation(menuArray.includes(1), isMobile)}
              onClick={() => isOpenSubMenu(1)}
            >
              {langs.technical[storeLanguage]}
              <DownArrow></DownArrow>
            </div>
            <PC>
              <ListComponent
                menuArray={menuArray}
                menuIdx={1}
                mainMenuClose={mainMenuClose}
                textArray={['tech', 'voucher']}
              />
            </PC>
          </div>
          <Mobile>
            <ListComponent
              menuArray={menuArray}
              menuIdx={1}
              mainMenuClose={mainMenuClose}
              textArray={['tech', 'voucher']}
            />
          </Mobile>
          {/* 서비스 소개  */}
          <div
            className={`menu_div  ${isMobile ? '' : headerHilightClass('', ['indj', 'flda'])}`}
          >
            <div
              className="menu_title"
              onClick={() => isOpenSubMenu(2)}
              css={svgAnimation(menuArray.includes(2), isMobile)}
            >
              {langs.service[storeLanguage]}
              <DownArrow></DownArrow>
            </div>
            <PC>
              <ListComponent
                menuArray={menuArray}
                menuIdx={2}
                mainMenuClose={mainMenuClose}
                textArray={['indj', 'flda']}
              />
            </PC>
          </div>
          <Mobile>
            <ListComponent
              menuArray={menuArray}
              menuIdx={2}
              mainMenuClose={mainMenuClose}
              textArray={['indj', 'flda']}
            />
          </Mobile>
          {/* inDJ 홈페이지 */}
          <div className="menu_div">
            <Link
              to="https://player.indj.ai/"
              onClick={() => mainMenuClose('')}
              target="_blank"
            >
              {langs.headerinDJ[storeLanguage]}
            </Link>
          </div>
          {/* News */}
          <div
            className={`menu_div ${isMobile ? '' : headerHilightClass('/news')}`}
          >
            <Link
              to={`${storeLanguage === 'ko' ? 'https://corp.indj.ai/news' : 'https://corp.indj.ai/news/en'}`}
              onClick={() => mainMenuClose('')}
            >
              News
            </Link>
          </div>
          {/* 문의하기 */}

          <div className="menu_div" onClick={() => mainMenuClose('contect')}>
            {langs.contact[storeLanguage]}
          </div>

          {/* 채용정보 */}
          <div className="menu_div">
            <Link
              to="https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=TXh6aFZrT29obTNaMlovOTQybXpHUT09"
              onClick={() => mainMenuClose('')}
              target="_blank"
            >
              {langs.recruitment[storeLanguage]}
            </Link>
          </div>
          <PC>
            <div className="pc_language">
              <div
                className="language_title"
                onClick={() => {
                  isOpenSubMenu(3)
                }}
              >
                <LanguageIcon />
                <DownArrow />
              </div>
              <ul
                className={`web_language_ul  ${menuArray.includes(3) ? 'language_ul_on' : 'language_ul_off'}`}
              >
                <li
                  className={`web_language_li ${storeLanguage === 'ko' ? 'web_language_li_on' : 'web_language_li_off'}`}
                  onClick={() => langOnClick('ko')}
                >
                  {storeLanguage === 'ko' ? <Cirlce /> : <></>}
                  한국어
                </li>
                {/* 번역완료후 */}
                {/* <div className="language_line"></div> */}
                {/* <li
                  className={`web_language_li ${storeLanguage === 'ko' ? 'web_language_li_off' : 'web_language_li_on'}`}
                  onClick={() => langOnClick('en')}
                >
                  {storeLanguage === 'ko' ? <></> : <Cirlce />}
                  English
                </li> */}
              </ul>
            </div>
          </PC>
          <Mobile>
            <div className="mobile_language">
              <div
                className="language_text_ko"
                onClick={() => langOnClick('ko')}
              >
                한국어
              </div>
              {/* 번역완료후 */}
              {/* <div className="language_line"></div>
              <div
                className="language_text_en"
                onClick={() => langOnClick('en')}
              >
                English
              </div> */}
            </div>
          </Mobile>
        </div>
      </div>
    </header>
  )
}

export default Header
